// Angular Core
import { Component, EventEmitter, Input, Output } from '@angular/core';
// Constants
import { BADGE_TYPE } from '@app/modules/shared/constants/custom.badge';

@Component({
    selector: 'app-custom-badge',
    templateUrl: './custom-badge.component.html',
    styleUrls: ['./custom-badge.component.scss'],
    standalone: false
})
export class CustomBadgeComponent {
  // Public variables
  public displayMessage = false;
  public BADGE_TYPE = BADGE_TYPE;
  // Event emitters
  @Output() onDispatchEvent = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();
  //Inputs
  @Input() header = '';
  @Input() body = '';
  @Input() buttonText = '';
  @Input() allowFunction = false;
  @Input() hasDescription = false;
  @Input() type = '';

  constructor() {}

  public onClickEvent() {
    this.onDispatchEvent.emit();
  }

  public getClassColor(className: string, type: any) {
    switch (type) {
      case BADGE_TYPE.ERROR:
        return className + '--error';
      case BADGE_TYPE.WARNING:
        return className + '--warning';
      case BADGE_TYPE.INFO:
        return className + '--info';
      case BADGE_TYPE.SUCCESS:
        return className + '--success';
      default:
        return className + '--info';
    }
  }

  closeModal() {
    this.onClose.emit(true);
  }
}
